import { connect } from 'react-redux';
import _values from 'lodash/values';
import _pickBy from 'lodash/pickBy';
import _keys from 'lodash/keys';
import {
  toggleGraphics,
  resizeChart,
  bubbleChart,
} from '../../actions/engineering';
import ChartCollection from '../../components/Charts/ChartCollection';

const mapStateToProps = (state, ownProps) => {
  let charts;
  let inSimulation = false;

  const unityIsLoading = state.unity.loading;
  const unityScene = state.unity.scene;

  // choose charts for the current unity scene
  if (unityScene === 0) {
    charts = _pickBy(
      state.engineering.charts.charts,
      (chart) => chart.scene === 'engineering'
    );
  } else if (unityScene === 1) {
    charts = _pickBy(
      state.engineering.charts.charts,
      (chart) => chart.scene === 'simulation'
    );
    inSimulation = true;
  }

  // apply positioning and sizes
  let autoZ = Object.keys(state.engineering.charts.coords).length;
  _keys(charts).forEach((key) => {
    const { width, height } = state.engineering.charts.charts[key];

    if (state.engineering.charts.coords.hasOwnProperty(key)) {
      const { x, y, z, size } = state.engineering.charts.coords[key];
      charts[key].coords = { x, y, z };

      if (width && height) {
        charts[key].size = [width, height];
        charts[key].hasOwnSize = true;
      } else {
        if (size) {
          charts[key].size = size;
        } else {
          charts[key].size = undefined;
        }
      }
    } else {
      charts[key].coords = { x: undefined, y: undefined, z: ++autoZ };
      if (width && height) {
        charts[key].size = [width, height];
        charts[key].hasOwnSize = true;
      } else {
        charts[key].size = undefined;
      }
    }
  });

  return {
    unityIsLoading,
    inSimulation,
    charts: _values(charts),
    ...ownProps,
  };
};

const mapDispatchToProps = {
  toggleGraphics,
  resizeChart,
  bubbleChart,
};

const Charts = connect(mapStateToProps, mapDispatchToProps)(ChartCollection);

export default Charts;
